import React, {useState} from 'react';
import styled from 'styled-components';
import {InputArea} from "../../../styled/StyledComponent";
import {MdClose} from "react-icons/md";
import SearchIcon from "../../../assets/images/icon/SearchIcon";

const SearchInputItem = (props) => {
    const [searchText, setSearchText] = useState("");
    const [focus, setFocus] = useState(false)

    return(
      <InputArea
          className={`${focus ? "on" : ""} addHeight yellow`}
      >
          <input
              onFocus={() => {
                  setFocus(true)
              }}
              onBlur={() => {
                  setFocus(false)
              }}
              value={searchText}
              onChange={(e) => {
                  setSearchText(e.target.value);
              }}
              type="text" placeholder="Search.."/>
          {
              searchText !== "" &&
              <div
                  onClick={() => {
                      setSearchText("")
                  }}
                  className="close">
                  <MdClose/>
              </div>
          }
          <div className={"searchBtn"}>
              <SearchIcon/>
              <span>Search</span>
          </div>
      </InputArea>
)

}
export default SearchInputItem;

const Container = styled.div`

`;